export const CUSTOMER_FIELDS_TABLE_DIMENSIONS = {
  STANDARD_CELL_WIDTH: 252,
  ACTIONS_CELL_WIDTH: 70,
  NAME_CELL_WIDTH: 322,
  MANDATORY_CELL_WIDTH: 98,
  VISIBILITY_CELL_WIDTH: 200,
  HEADING_ROW_HEIGHT: 40,
  ROW_HEIGHT: 74,
  REORDER_CELL_WIDTH: 48,
};

export const alwaysMandatoryPersonalFields = [
  "first_name",
  "phone_number",
  "email",
];

export const alwaysVisiblePersonalFields = [
  "first_name",
  "total_purchased",
  "last_order_placed",
];

export const alwaysVisibleCompanyFields = ["company_name"];
